import { useEffect, useRef, useState } from 'react'
import { normalizeImageCandidates } from '../../utils/imageCandidates'

function scrollSlideIntoTrack(track, index) {
  const slide = track?.children[index]
  if (!track || !slide) return
  const left = slide.offsetLeft - Math.max(0, (track.clientWidth - slide.clientWidth) / 2)
  track.scrollTo({ left, behavior: 'auto' })
}

export default function ScanImageCarousel({
  images = [],
  activeUrl = '',
  onSelect,
  onDisplayError,
}) {
  const slides = normalizeImageCandidates(images)
  const trackRef = useRef(null)
  const timerRef = useRef(0)
  const [index, setIndex] = useState(0)
  const [liveText, setLiveText] = useState('')

  useEffect(() => {
    const next = Math.max(0, slides.findIndex((slide) => slide.url === activeUrl))
    const safe = next < 0 ? 0 : next
    setIndex(safe)
    scrollSlideIntoTrack(trackRef.current, safe)
  }, [activeUrl, slides.map((slide) => slide.url).join('|')])

  useEffect(() => () => window.clearTimeout(timerRef.current), [])

  if (!slides.length) return null

  const commit = (nextIndex) => {
    const safe = Math.min(Math.max(nextIndex, 0), slides.length - 1)
    const slide = slides[safe]
    if (!slide) return
    setIndex(safe)
    setLiveText(`Image ${safe + 1} sur ${slides.length}`)
    if (slide.url !== activeUrl) onSelect?.(slide)
  }

  return (
    <div className="image-carousel-wrap">
      <div
        ref={trackRef}
        className="image-carousel"
        role="region"
        aria-roledescription="carrousel"
        aria-label="Images commerciales proposées"
        onScroll={(event) => {
          const width = Math.max(event.currentTarget.clientWidth, 1)
          const next = Math.round(event.currentTarget.scrollLeft / width)
          if (next !== index) setIndex(next)
          window.clearTimeout(timerRef.current)
          timerRef.current = window.setTimeout(() => commit(next), 80)
        }}
      >
        {slides.map((slide, slideIndex) => (
          <figure key={slide.url} className="image-carousel__slide">
            <img
              src={slide.url}
              alt=""
              draggable={false}
              onError={() => {
                if (slide.source_kind === 'capture') return
                onDisplayError?.(slide.url)
              }}
            />
            <span className="visually-hidden">Image {slideIndex + 1}</span>
          </figure>
        ))}
      </div>
      <div className="image-carousel-dots" aria-hidden="true">
        {slides.map((slide, slideIndex) => (
          <span key={slide.url} className={slideIndex === index ? 'is-active' : ''} />
        ))}
      </div>
      <p className="visually-hidden" aria-live="polite">{liveText}</p>
    </div>
  )
}
